var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2ZM19.7678 19.7678C20.2366 19.2989 20.5 18.663 20.5 18V6C20.5 5.33696 20.2366 4.70107 19.7678 4.23223C19.2989 3.76339 18.663 3.5 18 3.5H6C4.61929 3.5 3.5 4.61929 3.5 6V18C3.5 18.663 3.76339 19.2989 4.23223 19.7678C4.70107 20.2366 5.33696 20.5 6 20.5H18C18.663 20.5 19.2989 20.2366 19.7678 19.7678Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69 8.72996C15.3972 8.43751 14.9228 8.43751 14.63 8.72996L12.21 11.15L9.78999 8.72996C9.49448 8.4546 9.03398 8.46273 8.74837 8.74834C8.46276 9.03395 8.45463 9.49445 8.72999 9.78996L11.15 12.21L8.72999 14.63C8.43754 14.9228 8.43754 15.3971 8.72999 15.69C9.02281 15.9824 9.49717 15.9824 9.78999 15.69L12.21 13.27L14.63 15.69C14.7705 15.8307 14.9611 15.9098 15.16 15.91C15.358 15.9057 15.5471 15.8271 15.69 15.69C15.9824 15.3971 15.9824 14.9228 15.69 14.63L13.27 12.21L15.69 9.78996C15.9824 9.49714 15.9824 9.02278 15.69 8.72996Z",
    fill: "#1F1F1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRectangle);
export default __webpack_public_path__ + "static/media/Close-rectangle.8fdc8cd0.svg";
export { ForwardRef as ReactComponent };